import React from "react";
import "./CarrierComponent.css";
import fl from "../../images/fl.svg";
import marker from "../../images/marker-pin.svg";
import user from "../../images/user.svg";
import calendr from "../../images/calendar.svg";
import arrow from "../../images/evnt-arrow.png";

const CarrierComponent = () => {
  return (
    <div className="troo-da-career-section" id="troo-da-career-section">
      <div className="container">
        <div className="row">
          <div className="col-md-4">
            <div className="job-offer">
              <div className="job-title">
                <div className="opening">
                  <span>Opening</span>
                  <h3>02</h3>
                </div>
                <div className="job-name">
                  <strong>Yoga Teacher</strong>
                  <span>3.5 Year Experience</span>
                </div>
              </div>
              <div className="job-type">
                <ul>
                  <li>
                    <img src={fl} alt="fl" />
                    <strong>Job type:</strong>
                    <span> Full Time</span>
                  </li>
                  <li>
                    <img src={marker} alt="marker" />
                    <strong>Location:</strong>
                    <span>San Francisco, CA</span>
                  </li>
                  <li>
                    <img src={user} alt="user" />
                    <strong>Vacancy:</strong>
                    <span> 2 Open </span>
                  </li>
                  <li>
                    <img src={calendr} alt="calendr" /> <strong>Date:</strong>
                    <span> 22, December, 2022</span>
                  </li>
                </ul>
              </div>
              <div className="job-sign">
                <img src={arrow} alt="arrow" />
              </div>
            </div>
          </div>
          <div className="col-md-4">
            <div className="job-offer">
              <div className="job-title">
                <div className="opening">
                  <span>Opening</span>
                  <h3>02</h3>
                </div>
                <div className="job-name">
                  <strong>Finance Manager</strong>
                  <span>2.5 Year Experience</span>
                </div>
              </div>
              <div className="job-type">
                <ul>
                  <li>
                    <img src={fl} alt="fl" />
                    <strong>Job type:</strong>
                    <span> Full Time</span>
                  </li>
                  <li>
                    <img src={marker} alt="marker" />
                    <strong>Location:</strong>
                    <span>San Francisco, CA</span>
                  </li>
                  <li>
                    <img src={user} alt="user" />
                    <strong>Vacancy:</strong>
                    <span> 2 Open </span>
                  </li>
                  <li>
                    <img src={calendr} alt="calendr" /> <strong>Date:</strong>
                    <span> 22, December, 2022</span>
                  </li>
                </ul>
              </div>
              <div className="job-sign">
                <img src={arrow} alt="arrow" />
              </div>
            </div>
          </div>
          <div className="col-md-4">
            <div className="job-offer">
              <div className="job-title">
                <div className="opening">
                  <span>Opening</span>
                  <h3>02</h3>
                </div>
                <div className="job-name">
                  <strong>Human Resource</strong>
                  <span>5 Year Experience</span>
                </div>
              </div>
              <div className="job-type">
                <ul>
                  <li>
                    <img src={fl} alt="fl" />
                    <strong>Job type:</strong>
                    <span> Full Time</span>
                  </li>
                  <li>
                    <img src={marker} alt="marker" />
                    <strong>Location:</strong>
                    <span>San Francisco, CA</span>
                  </li>
                  <li>
                    <img src={user} alt="user" />
                    <strong>Vacancy:</strong>
                    <span> 2 Open </span>
                  </li>
                  <li>
                    <img src={calendr} alt="calendr" /> <strong>Date:</strong>
                    <span> 22, December, 2022</span>
                  </li>
                </ul>
              </div>
              <div className="job-sign">
                <img src={arrow} alt="arrow" />
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-4">
            <div className="job-offer">
              <div className="job-title">
                <div className="opening">
                  <span>Opening</span>
                  <h3>02</h3>
                </div>
                <div className="job-name">
                  <strong>Senior Editor</strong>
                  <span>2.5 Year Experience</span>
                </div>
              </div>
              <div className="job-type">
                <ul>
                  <li>
                    <img src={fl} alt="fl" />
                    <strong>Job type:</strong>
                    <span> Full Time</span>
                  </li>
                  <li>
                    <img src={marker} alt="marker" />
                    <strong>Location:</strong>
                    <span>San Francisco, CA</span>
                  </li>
                  <li>
                    <img src={user} alt="user" />
                    <strong>Vacancy:</strong>
                    <span> 2 Open </span>
                  </li>
                  <li>
                    <img src={calendr} alt="calendr" /> <strong>Date:</strong>
                    <span> 22, December, 2022</span>
                  </li>
                </ul>
              </div>
              <div className="job-sign">
                <img src={arrow} alt="arrow" />
              </div>
            </div>
          </div>
          <div className="col-md-4">
            <div className="job-offer">
              <div className="job-title">
                <div className="opening">
                  <span>Opening</span>
                  <h3>02</h3>
                </div>
                <div className="job-name">
                  <strong>Technical Engineer</strong>
                  <span>1 Year Experience</span>
                </div>
              </div>
              <div className="job-type">
                <ul>
                  <li>
                    <img src={fl} alt="fl" />
                    <strong>Job type:</strong>
                    <span> Full Time</span>
                  </li>
                  <li>
                    <img src={marker} alt="marker" />
                    <strong>Location:</strong>
                    <span>San Francisco, CA</span>
                  </li>
                  <li>
                    <img src={user} alt="user" />
                    <strong>Vacancy:</strong>
                    <span> 2 Open </span>
                  </li>
                  <li>
                    <img src={calendr} alt="calendr" /> <strong>Date:</strong>
                    <span> 22, December, 2022</span>
                  </li>
                </ul>
              </div>
              <div className="job-sign">
                <img src={arrow} alt="arrow" />
              </div>
            </div>
          </div>
          <div className="col-md-4">
            <div className="job-offer">
              <div className="job-title">
                <div className="opening">
                  <span>Opening</span>
                  <h3>02</h3>
                </div>
                <div className="job-name">
                  <strong>Technical Writer</strong>
                  <span>2 Year Experience</span>
                </div>
              </div>
              <div className="job-type">
                <ul>
                  <li>
                    <img src={fl} alt="fl" />
                    <strong>Job type:</strong>
                    <span> Full Time</span>
                  </li>
                  <li>
                    <img src={marker} alt="marker" />
                    <strong>Location:</strong>
                    <span>San Francisco, CA</span>
                  </li>
                  <li>
                    <img src={user} alt="user" />
                    <strong>Vacancy:</strong>
                    <span> 2 Open </span>
                  </li>
                  <li>
                    <img src={calendr} alt="calendr" /> <strong>Date:</strong>
                    <span> 22, December, 2022</span>
                  </li>
                </ul>
              </div>
              <div className="job-sign">
                <img src={arrow} alt="arrow" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CarrierComponent;
